import { IWhatIfTopic } from 'src/core/repo/whatif/types';
import styles from './selectTopic.module.scss';
import { Input, Tag } from 'antd';
import { FaSearch } from 'react-icons/fa';
import { FaX } from 'react-icons/fa6';
import { ReactNode, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GoChevronLeft } from 'react-icons/go';

interface Props {
  topics: IWhatIfTopic[];
  handleSelectTopic: (topicId: IWhatIfTopic) => void;
  theme: 'night' | 'day';
  onBack: () => void;
}

const SelectTopic = ({ topics, handleSelectTopic, theme, onBack }: Props) => {
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [query, setQuery] = useState<string>('');
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChange = (tag: number, checked: boolean) => {
    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : selectedTags.filter((t) => t !== tag);
    setSelectedTags(nextSelectedTags);
  };
  const filteredTopics = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return topics.filter((t) => {
      const matchesQuery =
        !normalized || t.Title.toLowerCase().includes(normalized);
      const matchesSelectedTags =
        selectedTags.length === 0 || selectedTags.includes(t.TrainingTopicID);
      return matchesQuery && matchesSelectedTags;
    });
  }, [query, topics, selectedTags]);

  const language = searchParams.get('lang');
  const colors = [
    { bg: '#FFD33826', text: '#222' }, // روشن
    { bg: '#9C1DE826', text: '#222' }, // روشن
    { bg: '#F1568F26', text: '#222' }, // روشن
    { bg: '#B0E0E626', text: '#222' }, // روشن
    { bg: '#CBAACB26', text: '#222' }, // روشن
    { bg: '#FFD1DC26', text: '#222' }, // روشن
    { bg: '#F8F8F8', text: '#222' }, // روشن
    { bg: 'rgba(186, 109, 232, 0.5)', text: '#fff' }, // روشن
    { bg: '#622E9D26', text: '#000' }, // روشن

    // پاستیلی‌ها
    { bg: '#F8F8F8', text: '#222' }, // روشن
    { bg: '#B0E0E626', text: '#222' }, // روشن
    { bg: '#622E9D26', text: '#222' }, // روشن
    { bg: '#F1568F26', text: '#222' }, // روشن
    { bg: '#F1568F26', text: '#222' }, // روشن  ];
  ];

  return (
    <div className={styles.container}>
      <div className={styles.description_wrapper}>
        <button onClick={onBack} className={styles.back_button}>
          <GoChevronLeft size={22} />
          <p>Back</p>
        </button>
        <h1 style={{ color: theme === 'night' ? '#fff' : '#000' }}>
          Select your topic
        </h1>
      </div>
      {/* search input for topics */}
      <div className={styles.filter_methods}>
        <Input
          size="large"
          variant="outlined"
          placeholder="Search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          prefix={<FaSearch />}
          addonAfter={<FaX onClick={() => setQuery('')} />}
        />
      </div>
      {/* quick asses topic */}
      <div
        className={styles.topic_tags}
        dir={language === 'Persian' ? 'rtl' : 'ltr'}
        lang={language === 'Persian' ? 'fa' : 'en'}>
        {topics.map<ReactNode>((tag) => (
          <Tag.CheckableTag
            key={tag.TrainingTopicID}
            checked={selectedTags.includes(tag.TrainingTopicID)}
            onChange={(checked) => handleChange(tag.TrainingTopicID, checked)}>
            {tag.Title}
          </Tag.CheckableTag>
        ))}
      </div>
      {/* topic cards */}
      <div className={styles.topic_cards}>
        {filteredTopics.map((topic, idx) => {
          const { bg, text } = colors[idx % colors.length];
          return (
            <div
              dir={topic.dir}
              onClick={() => handleSelectTopic(topic)}
              key={topic.TrainingTopicID}
              style={{ backgroundColor: bg }}
              className={styles.topic_card}>
              <div className={styles.topic_card_desc}>
                <h3>{topic.Title}</h3>
                <p>{topic.Description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectTopic;
